import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNoChange = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={18}
    fill="none"
    {...props}
  >
    <path
      fill="url(#NoChange_svg__a)"
      fillRule="evenodd"
      d="M.9.9a.9.9 0 0 0 0 1.8h16.8a.9.9 0 1 0 0-1.8zm0 4.8a.9.9 0 0 0 0 1.8h5.185a6.9 6.9 0 0 0-.782 3H.9a.9.9 0 1 0 0 1.8h4.586a6.9 6.9 0 1 0 1.958-6.6zm15.8 5a.9.9 0 0 1-.9.9h-7a.9.9 0 0 1 0-1.8h7a.9.9 0 0 1 .9.9"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="NoChange_svg__a"
        x1={-3.7}
        x2={24.8}
        y1={-2.5}
        y2={19.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E0E3E9" />
        <stop offset={1} stopColor="#B3BBCB" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgNoChange;
